import React, { useState, useRef, useEffect } from "react"
import Transition from "../utils/Transition.js"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { analyticsAction } from "/src/utils/analytics"

function HomeFeaturesTabs() {
  const [tab, setTab] = useState(1)
  const tabs = useRef(null)

  /*const heightFix2 = () => {
    if (tabs.current.children[tab] && tab !== 1) {
      tabs.current.style.height =
        tabs.current.children[tab - 1].offsetHeight + "px"
    }
  }

  const heightFix = () => {
    if (tabs.current && tabs.current.parentElement)
      tabs.current.parentElement.style.height = `${tabs.current.clientHeight}px`
  }*/

  useEffect(() => {
    //heightFix()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab])

  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="py-12 md:py-20 border-t border-gray-800">
          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12" data-aos-id-tabs>
            <h2
              className="h2 mb-4"
              data-aos="fade-up"
              data-aos-anchor="[data-aos-id-tabs]"
            >
              Enjoy our features
            </h2>
            <p
              className="text-xl text-gray-400"
              data-aos="fade-up"
              data-aos-delay="200"
              data-aos-anchor="[data-aos-id-tabs]"
            >
              Automate every step of pre-production in one place.
            </p>
          </div>

          {/* Section content */}
          <div>
            {/* Tabs buttons */}
            <div
              className="flex flex-wrap min-[1105px]:justify-between justify-center gap-0.5"
              data-aos="fade-up"
              data-aos-delay="400"
              data-aos-anchor="[data-aos-id-tabs]"
            >
              <button
                className={`w-full sm:w-auto justify-center flex items-center hover:opacity-85 font-medium py-4 px-3 bg-gray-800 text-[13px] group transition duration-500 ${
                  tab !== 1 && "opacity-50"
                }`}
                onClick={() => setTab(1)}
              >
                <span className="text-gray-300 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  <span className="mr-1.5" role="img" aria-label="">
                    📜
                  </span>
                  AI Script Breakdown
                </span>
              </button>

              <button
                className={`w-full sm:w-auto justify-center flex items-center hover:opacity-85 font-medium py-4 px-3 bg-gray-800 text-[13px] group transition duration-500 ${
                  tab !== 2 && "opacity-50"
                }`}
                onClick={() => setTab(2)}
              >
                <span className="text-gray-300 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  <span className="mr-1.5" role="img" aria-label="">
                    💥
                  </span>
                  AI VFX Breakdown
                </span>
              </button>

              <button
                className={`w-full sm:w-auto justify-center flex items-center hover:opacity-85 font-medium py-4 px-3 bg-gray-800 text-[13px] group transition duration-500 ${
                  tab !== 3 && "opacity-50"
                }`}
                onClick={() => setTab(3)}
              >
                <span className="text-gray-300 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  <span className="mr-1.5" role="img" aria-label="">
                    📆
                  </span>
                  AI Shooting Schedules
                </span>
              </button>

              <button
                className={`w-full sm:w-auto justify-center flex items-center hover:opacity-85 font-medium py-4 px-3 bg-gray-800 text-[13px] group transition duration-500 ${
                  tab !== 4 && "opacity-50"
                }`}
                onClick={() => setTab(4)}
              >
                <span className="text-gray-300 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  <span className="mr-1.5" role="img" aria-label="">
                    📋
                  </span>
                  Call Sheets
                </span>
              </button>

              <button
                className={`w-full sm:w-auto justify-center flex items-center hover:opacity-85 font-medium py-4 px-3 bg-gray-800 text-[13px] group transition duration-500 ${
                  tab !== 5 && "opacity-50"
                }`}
                onClick={() => setTab(5)}
              >
                <span className="text-gray-300 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  <span className="mr-1.5" role="img" aria-label="">
                    📝
                  </span>
                  AI Script Synopsis
                </span>
              </button>

              <button
                className={`w-full sm:w-auto justify-center flex items-center hover:opacity-85 font-medium py-4 px-3 bg-gray-800 text-[13px] group transition duration-500 ${
                  tab !== 6 && "opacity-50"
                }`}
                onClick={() => setTab(6)}
              >
                <span className="text-gray-300 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  <span className="mr-1.5" role="img" aria-label="">
                    🔎
                  </span>
                  AI Script Analysis
                </span>
              </button>

              <button
                className={`relative w-full sm:w-auto justify-center flex items-center hover:opacity-85 font-medium py-4 px-3 bg-gray-800 text-[13px] group transition duration-500 ${
                  tab !== 7 && "opacity-50"
                }`}
                onClick={() => setTab(7)}
              >
                {/*<div className="absolute -right-2 sm:-right-5 -top-2 lg:-top-4 z-10">
                  <div className="inline-flex  text-sm font-semibold py-1 px-2 mt-px text-green-600 bg-green-200 rounded-full capitalize">
                    Soon
                  </div>
                </div>*/}
                <span className="text-gray-300 group-hover:text-gray-200 transition-colors duration-150 ease-in-out">
                  <span className="mr-1.5" role="img" aria-label="">
                    💸
                  </span>
                  AI Budgeting
                </span>
              </button>
            </div>

            {/* Tabs items */}
            <div
              className="relative flex flex-col mt-8"
              data-aos="fade-up"
              ref={tabs}
            >
              {/* Item 1 */}
              <Transition
                show={tab === 1}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-full mx-auto md:max-w-none shadow-2xl shadow-indigo-500/30">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:pl-6 md:w-1/2 opacity-90">
                    <StaticImage
                      quality={80}
                      objectFit="cover"
                      objectPosition="right top"
                      className="w-full h-full"
                      src="../images/film/features/home/01-script-breakdown.png"
                      alt="Complete Script Breakdown in Just Minutes"
                      placeholder="none"
                      loading="eager"
                    />
                  </figure>

                  <div className="relative bg-gray-800 py-8 md:py-12 px-8 md:px-12 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-5">
                      Complete Script Breakdown in Just Minutes
                    </h4>

                    <p className="text-gray-400">
                      Script breakdowns are essential for pre-production,
                      impacting budgeting, scheduling, and logistics.
                      Traditional methods can be frustrating and tedious,
                      requiring manual input on printed sheets. Filmustage
                      offers a streamlined solution to these challenges.
                    </p>

                    <p className="font-bold text-gray-400 mt-5">
                      Filmustage automatically identifies critical script
                      elements such as cast, props, locations, VFX, and more,
                      streamlining the planning process, saving invaluable time
                      and costs, and making pre-production planning more
                      efficient and less prone to errors.
                    </p>

                    <Link
                      className="btn-sm capitalize bg-fPurple-800 hover:bg-fPurple-900 mt-6"
                      to="/script-breakdown/"
                      onClick={() =>
                        analyticsAction("landing_script_breakdown_click")
                      }
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </Link>
                  </div>
                </article>
              </Transition>

              {/* Item 2 */}
              <Transition
                show={tab === 2}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-full mx-auto md:max-w-none shadow-2xl shadow-indigo-500/30">
                  <figure className="md:absolute md:inset-y-0 md:left-0 md:pr-6 md:w-1/2 opacity-90">
                    <StaticImage
                      quality={80}
                      objectFit="cover"
                      objectPosition="-18px top"
                      className="w-full h-full"
                      src="../images/film/features/home/06-vfx-breakdown.png"
                      alt="Get VFX Breakdown with Detailed Sequences"
                      placeholder="none"
                      loading="eager"
                    />
                  </figure>

                  <div className="relative bg-gray-800 py-8 md:py-12 px-8 md:px-12 md:max-w-lg lg:max-w-xl md:ml-auto">
                    <h4 className="h4 mb-5">
                      Get VFX Breakdown with Detailed Sequences
                    </h4>

                    <p className="text-gray-400">
                      VFX planning and bidding often require significant time
                      and can be prone to errors when done manually.
                    </p>

                    <p className="font-bold text-gray-400 mt-5">
                      Automatic VFX Breakdown eliminates these challenges by
                      providing fast, accurate, and detailed insights from the
                      outset. This innovative tool ensures all effects-related
                      details are thoroughly organized, easy to understand, and
                      ready for implementation, keeping productions on track and
                      within budget effortlessly.
                    </p>

                    <Link
                      className="btn-sm capitalize bg-fPurple-800 hover:bg-fPurple-900 mt-6"
                      to="/vfx-breakdown/"
                      onClick={() =>
                        analyticsAction("landing_vxf_breakdown_click")
                      }
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </Link>
                  </div>
                </article>
              </Transition>

              {/* Item 3 */}
              <Transition
                show={tab === 3}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-full mx-auto md:max-w-none shadow-2xl shadow-indigo-500/30">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:pl-6 md:w-1/2 opacity-90">
                    <StaticImage
                      quality={80}
                      objectFit="cover"
                      objectPosition="right top"
                      className="w-full h-full"
                      src="../images/film/features/home/02-scheduling.png"
                      alt="Create and Manage Shooting Schedules and DOOD Reports"
                      placeholder="none"
                      loading="eager"
                    />
                  </figure>

                  <div className="relative bg-gray-800 py-8 md:py-12 px-8 md:px-12 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-5">
                      Create and Manage Shooting Schedules and DOOD Reports
                    </h4>

                    <p className="text-gray-400">
                      Manual shooting scheduling, vital for the seamless
                      execution of film productions, is often fraught with
                      inefficiencies and prone to errors, making the
                      coordination of cast, crew, and resources a complex
                      challenge.
                    </p>

                    <p className="font-bold text-gray-400 mt-5">
                      Filmustage simplifies film scheduling by features like
                      auto time estimates, real location tagging, drag-and-drop
                      scene management, AI sorting, and automated call sheets,
                      enhancing precision and saving time, for a streamlined
                      film production process.
                    </p>

                    <Link
                      className="btn-sm capitalize bg-fPurple-800 hover:bg-fPurple-900 mt-6"
                      to="/shooting-schedules/"
                      onClick={() =>
                        analyticsAction("landing_shooting_schedules_click")
                      }
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </Link>
                  </div>
                </article>
              </Transition>

              {/* Item 4 */}
              <Transition
                show={tab === 4}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-full mx-auto md:max-w-none shadow-2xl shadow-indigo-500/30">
                  <figure className="md:absolute md:inset-y-0 md:left-0 md:pr-6 md:w-1/2 opacity-90">
                    <StaticImage
                      quality={80}
                      objectFit="cover"
                      objectPosition="left top"
                      className="w-full h-full"
                      src="../images/film/features/home/08-call-sheets.png"
                      alt="Create and Manage Shooting Schedules and DOOD Reports"
                      placeholder="none"
                      loading="eager"
                    />
                  </figure>

                  <div className="relative bg-gray-800 py-8 md:py-12 px-8 md:px-12 md:max-w-lg lg:max-w-xl md:ml-auto">
                    <h4 className="h4 mb-5">Generate Detailed Call Sheets</h4>

                    <p className="text-gray-400">
                      Creating call sheets can be a complex and time-consuming
                      process, requiring precision and attention to detail.
                      Manually converting shooting schedules into organized
                      documents often leads to errors and unnecessary delays.
                    </p>

                    <p className="font-bold text-gray-400 mt-5">
                      Automatically transform your shooting schedule into
                      professional, detailed call sheets with Filmustage. Our
                      platform simplifies the process, turning your data into
                      customizable and editable call sheets tailored to your
                      production. Adjust times, crew details, locations, and
                      more to fit your needs — all while ensuring accuracy and
                      saving valuable time.
                    </p>

                    <Link
                      className="btn-sm capitalize bg-fPurple-800 hover:bg-fPurple-900 mt-6"
                      to="/call-sheets/"
                      onClick={() =>
                        analyticsAction("landing_call_sheets_click")
                      }
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </Link>
                  </div>
                </article>
              </Transition>

              {/* Item 5 */}
              <Transition
                show={tab === 5}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-full mx-auto md:max-w-none shadow-2xl shadow-indigo-500/30">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:pl-6 md:w-1/2 opacity-100">
                    <StaticImage
                      quality={80}
                      objectFit="cover"
                      objectPosition="right center"
                      className="w-full h-full"
                      src="../images/film/features/home/03-synopsis.png"
                      alt="Create a Full Script or Scene Synopsis Automatically"
                      placeholder="none"
                      loading="eager"
                    />
                  </figure>

                  <div className="relative bg-gray-800 py-8 md:py-12 px-8 md:px-12 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-5">
                      Create a Full Script or Scene Synopsis Automatically
                    </h4>

                    <p className="text-gray-400">
                      Script synopses, essential for filmmaking stages from
                      pitching to production, traditionally demanded lengthy
                      reading and summarizing.
                    </p>

                    <p className="font-bold text-gray-400 mt-5">
                      Forget the time-consuming process! Filmustage is here to
                      automate it, delivering comprehensive synopses in just
                      minutes.
                    </p>

                    <Link
                      className="btn-sm capitalize bg-fPurple-800 hover:bg-fPurple-900 mt-6"
                      to="/ai-script-synopsis/"
                      onClick={() =>
                        analyticsAction("landing_ai_script_synopsis_click")
                      }
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </Link>
                  </div>
                </article>
              </Transition>

              {/* Item 6 */}
              <Transition
                show={tab === 6}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-full mx-auto md:max-w-none shadow-2xl shadow-indigo-500/30">
                  <figure className="md:absolute md:inset-y-0 md:left-0 md:pr-6 md:w-1/2 opacity-90">
                    <StaticImage
                      quality={80}
                      objectFit="cover"
                      objectPosition="top center"
                      className="w-full h-full"
                      src="../images/film/features/home/04-analysis.png"
                      alt="Analyze Risks in Your Script Using AI"
                      placeholder="none"
                      loading="eager"
                    />
                  </figure>

                  <div className="relative bg-gray-800 py-8 md:py-12 px-8 md:px-12 md:max-w-lg lg:max-w-xl md:ml-auto">
                    <h4 className="h4 mb-5">
                      Analyze Risks in Your Script Using AI
                    </h4>

                    <p className="text-gray-400">
                      The script, beyond a narrative, includes legal, safety,
                      and pre-production challenges, ensuring a smooth
                      translation of the story to the screen.
                    </p>

                    <p className="font-bold text-gray-400 mt-5">
                      To prevent these critical evaluations from hindering the
                      creative flow and consuming valuable time and human
                      resources, Filmustage will undertake these
                      responsibilities through its AI Analysis feature.
                    </p>

                    <Link
                      className="btn-sm capitalize bg-fPurple-800 hover:bg-fPurple-900 mt-6"
                      to="/ai-script-analysis/"
                      onClick={() =>
                        analyticsAction("landing_ai_script_analysis_click")
                      }
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </Link>
                  </div>
                </article>
              </Transition>

              {/* Item 7 */}
              <Transition
                show={tab === 7}
                appear={true}
                className="w-full"
                enter="transition ease-in-out duration-500 transform order-first"
                enterStart="opacity-0 scale-98"
                enterEnd="opacity-100 scale-100"
                leave="transition ease-out duration-300 transform absolute"
                leaveStart="opacity-100 scale-100"
                leaveEnd="opacity-0 scale-98"
              >
                <article className="relative max-w-full mx-auto md:max-w-none shadow-2xl shadow-indigo-500/30">
                  <figure className="md:absolute md:inset-y-0 md:right-0 md:pl-6 md:w-1/2 opacity-90">
                    <img
                      className="w-full h-full object-cover"
                      src={
                        require("../images/film/features/home/05-budgeting.png")
                          .default
                      }
                      alt="Estimate the Budget of Your Project"
                    />
                  </figure>

                  <div className="relative bg-gray-800 py-8 md:py-12 px-8 md:px-12 md:max-w-lg lg:max-w-xl">
                    <h4 className="h4 mb-5">
                      Estimate the Budget of Your Project
                    </h4>

                    <p className="text-gray-400">
                      Manual budgeting in film production is a time-consuming,
                      error-prone process that lacks flexibility and
                      collaboration, leading to inefficiencies in cost
                      management and forecasting.
                    </p>

                    <p className="font-bold text-gray-400 mt-5">
                      Filmustage transforms the budgeting process by seamlessly
                      integrating breakdown results and tax considerations into
                      an intuitive tool that merges the clarity of classic
                      templates with the adaptability of spreadsheets,
                      streamlining cost planning and reducing manual effort.
                    </p>

                    <Link
                      className="btn-sm capitalize bg-fPurple-800 hover:bg-fPurple-900 mt-6"
                      to="/budgeting/"
                      onClick={() => analyticsAction("landing_budgeting_click")}
                    >
                      <span className="text-sm">Learn more</span>
                      <svg
                        className="w-3 h-3 fill-current text-purple-400 flex-shrink-0 ml-2"
                        viewBox="0 0 12 12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M6 5H0v2h6v4l6-5-6-5z" />
                      </svg>
                    </Link>
                  </div>
                </article>
              </Transition>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HomeFeaturesTabs
